"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeStatus = void 0;
const getIdsForAction_1 = require("./getIdsForAction");
function changeStatus(props, storage, status, selectedRowIds, filterData, sortColumnKey, sortColumnDesc) {
    return __awaiter(this, void 0, void 0, function* () {
        const ids = yield (0, getIdsForAction_1.getIdsForAction)(props, storage, selectedRowIds, filterData, sortColumnKey, sortColumnDesc);
        for (const id of ids) {
            yield storage.post({
                action: 'partial-update',
                id: id,
                data: {
                    status: status,
                },
            });
        }
    });
}
exports.changeStatus = changeStatus;
